/* eslint-disable @typescript-eslint/no-unused-vars */
import { Draft, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IHistoryManagementState } from "types/models/history-management";
import { RootState } from "types/reducer";

const initialState: IHistoryManagementState = {
  historys: []
};

const HistoryManagementSlice = createSlice({
  name: "history-management",
  initialState,
  reducers: {
    fetchHistorys(
      state: Draft<IHistoryManagementState>,
      action: PayloadAction<any>
    ){

    },
    fetchHistorysSuccess(
      state: Draft<IHistoryManagementState>,
      action: PayloadAction<any[]>
    ){
      state.historys = action.payload;
    },
    deleteHistory(
      state: Draft<IHistoryManagementState>,
      action: PayloadAction<any>
    ){
    },
    deleteHistorySuccess(
      state: Draft<IHistoryManagementState>,
      action: PayloadAction<any[]>
    ){
      state.historys = action.payload;
    },
    clearHistorys(
      state: Draft<IHistoryManagementState>,
    ){
      state.historys = initialState.historys;
    },
  },
});

// Actions
export const fetchHistorys = HistoryManagementSlice.actions.fetchHistorys;
export const fetchHistorysSuccess = HistoryManagementSlice.actions.fetchHistorysSuccess;

export const deleteHistory = HistoryManagementSlice.actions.deleteHistory;
export const deleteHistorySuccess = HistoryManagementSlice.actions.deleteHistorySuccess;

export const clearHistorys = HistoryManagementSlice.actions.clearHistorys;

// Selectors
export const getHistorys = (state: RootState) => state.history_management.historys;

// Reducer
const HistoryManagementReducer = HistoryManagementSlice.reducer;
export default HistoryManagementReducer;
